import { makeObservable, observable, action } from 'mobx'

class Menu {

    open = false

    constructor() {
        makeObservable( this, {
            set: action,
            open: observable
        } )
    }

    set( open ) {
        this.open = open
    }

}


export default new Menu()
